import { registerCollectionItemsQuery } from 'marketplace-ui-common/collections/queries/collectionItemsQuery';
import { createCollectionItemsSchema } from 'marketplace-ui-common/collections/types/CollectionItems';
import { appSearchResponseItemSchema } from '../../search/types';
export const GET_APP_COLLECTION_ITEMS = registerCollectionItemsQuery({
  offeringType: 'APP',
  fieldName: 'appCollectionItems',
  schema: createCollectionItemsSchema(appSearchResponseItemSchema)
});